import React, { useMemo } from 'react';
import { Breadcrumb } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { generateBreadcrumbs, routes } from '../../utils/breadcrumb.utils';

export const AppBreadcrumb: React.FC = () => {
  const location = useLocation();
  
  const items = useMemo(() => {
    const breadcrumbs = generateBreadcrumbs(location.pathname, routes);
    
    return breadcrumbs.map((item) => ({
      title: item.isActive ? (
        <span aria-current="page">{item.title}</span>
      ) : (
        <Link 
          to={item.path}
          aria-label={`Ir para ${item.title}`}
        >
          {item.title}
        </Link>
      ),
    }));
  }, [location.pathname]);

  return <Breadcrumb items={items} aria-label="Navegação por migalhas de pão" />;
};
